<template>
  <div :style="containerStyle" class="form-group">
    <label v-if="showLabels" :for="name">{{ title }}
      <span v-show="required" class="text-danger">*</span>
      <info-tooltip v-if="helperText" :helper-text="helperText" />
    </label>
    <multiselect
        v-model="modelProxy"
        :allow-empty="allowEmpty"
        :deselectGroupLabel="$t('general.please_enter_to_deselect_group')"
        :deselectLabel="$t('general.please_enter_to_remove')"
        :disabled="disabled"
        :label="label"
        :max-height="maxHeight"
        :multiple="multiple"
        :open-direction="openDirection"
        :options="values"
        :placeholder="$t('general.select_option')"
        :searchable="searchable"
        :selectGroupLabel="$t('general.please_enter_to_select_group')"
        :selectLabel="$t('general.please_enter_to_select')"
        :selectedLabel="$t('general.selected')"
        :show-labels="showLabels"
        :style="controlHeightStyle"
        :tagPlaceholder="tagPlaceholder || $t('general.please_enter_to_create_tag')"
        :taggable="taggable"
        :track-by="trackBy"
        class="custom-multiselect"
        @select="onSelect"
        @tag="addTag"
    >
      <!-- NoResult slot -->
      <template slot="noResult">
        <slot name="noResult">
          {{ $t('general.no_result_found') }}
        </slot>
      </template>

    </multiselect>
    <!--    <select :multiple="multiple" class="form-control" :id="name" v-model="modelProxy" :required="required" :disabled="disabled">-->
    <!--      <option :value="index" v-for="(value, index) in values">{{ $t(value) }}</option>-->
    <!--    </select>-->
    <p v-if="error" class="text-danger pt-1 px-3 block">{{ error }}</p>
  </div>
</template>

<script>

import 'vue-multiselect/dist/vue-multiselect.min.css'
import InfoTooltip from "@/assets/components/widget/InfoTooltip";

export default {
  name: "MultipleSelectInput",
  props: {
    value: {
      default: null
    },
    showLabels: {
      required: false,
      default: true,
    },
    title: {},
    name: {},
    values: {},
    error: {},
    model: {},
    required: {
      required: false,
      default: false,
    },
    disabled: {
      required: false,
      default: false
    },
    allowEmpty: {
      required: false,
      default: true
    },
    trackBy: {
      required: false,
      default: "id"
    },
    label: {
      required: false,
      default: "name"
    },
    searchable: {
      required: false,
      default: false
    },
    multiple: {
      required: false,
      default: false,
    },
    taggable: {
      type: Boolean,
      default: false,
    },
    tagPlaceholder: {
      type: String,
      default: ""
    },
    helperText: {
      default: null,
      required: false,
      type: String,
    },
    openDirection: {
      type: String,
      default: "",
    },
    controlHeight: {
      type: [Number, String],
      default: null,
    },
    minWidth: {
      type: [Number, String],
      default: null,
    },
    maxHeight: {
      type: Number,
      default: 150,
    },
  },
  components: {
    InfoTooltip
  },
  methods: {
    onSelect(value) {
      this.$emit('select', value)
    },
    addTag(newTag) {
      const tag = {
        [this.label]: newTag,
        [this.trackBy]: newTag
      }
      this.$emit('addTag', tag)

      // Yeni etiketi seçenekler listesine ekle
      if (this.values && Array.isArray(this.values)) {
        this.values.push(tag)
      }

      // Multiple mod kontrolü
      if (this.multiple) {
        // Model değeri henüz tanımlanmamışsa, yeni bir dizi oluştur
        if (!this.modelProxy) {
          this.$emit('update:model', [tag])
        }
        // Model değeri dizi değilse, dizi haline getir ve yeni etiketi ekle
        else if (!Array.isArray(this.modelProxy)) {
          const currentValue = this.modelProxy
          this.$emit('update:model', currentValue ? [currentValue, tag] : [tag])
        }
        // Model değeri bir dizi ise, doğrudan etiketi ekle
        else {
          this.modelProxy.push(tag)
        }
      } else {
        // Tekli seçim için sadece modeli güncelle
        this.$emit('update:model', tag)
      }

      // Yeni etiket için select olayını tetikle
      this.onSelect(tag)
    }
  },
  computed: {
    containerStyle() {
      const minWidth = Number(this.minWidth)

      if (!Number.isFinite(minWidth) || minWidth <= 0) {
        return {}
      }

      return {
        minWidth: `${minWidth}px`,
      }
    },
    controlHeightStyle() {
      const height = Number(this.controlHeight)

      if (!Number.isFinite(height) || height <= 0) {
        return {}
      }

      return {
        "--multiple-select-control-height": `${height}px`,
      }
    },
    modelProxy: {
      get() {
        return this.model !== undefined ? this.model : this.value
      },
      set(value) {
        this.$emit('update:model', value)
        this.$emit('input', value)
      }
    }
  },
}
</script>

<style scoped>
.multiselect {
  height: 40px !important;
}

@media (max-width: 959px) {
  .multiselect {
    height: var(--multiple-select-control-height, 40px) !important;
  }
}
</style>

<style>
/* Boş tag durumunda stil düzeltmeleri */
.custom-multiselect .multiselect__tag:empty {
  display: none !important;
  padding: 0 !important;
  margin: 0 !important;
  border: none !important;
  background: transparent !important;
}

.custom-multiselect .multiselect__single:empty {
  display: none !important;
}

.custom-multiselect .multiselect__tags:empty {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.custom-multiselect .multiselect__tags {
  min-height: 38px;
}

.custom-multiselect .multiselect__select {
  height: 40px;
}

@media (max-width: 959px) {
  .custom-multiselect .multiselect__tags {
    min-height: var(--multiple-select-control-height, 38px);
  }

  .custom-multiselect .multiselect__select {
    height: var(--multiple-select-control-height, 40px);
  }
}

.custom-multiselect .multiselect__tag:empty + .multiselect__tag-icon {
  display: none !important;
}

.custom-multiselect .multiselect__tag:has(> span:empty) {
  display: none !important;
}

.custom-multiselect .multiselect__tag {
  display: inline-flex;
  align-items: center;
}

.custom-multiselect .multiselect__tag span:empty {
  display: none !important;
}

.custom-multiselect .multiselect__tag span:empty + .multiselect__tag-icon {
  display: none !important;
}

.custom-multiselect .multiselect__input {
  height: 0;
  padding: 0;
  margin: 0;
  border: none;
  overflow: hidden;
}
</style>
